import type { SeedCandidate } from "@/stores/seed-discovery-store";
import type { PaperCreate } from "@/types/paper";

export function candidateToPaperCreate(c: SeedCandidate): PaperCreate {
  return {
    paper_id: c.paper_id, title: c.title, authors: c.authors,
    year: c.year ?? undefined, abstract: c.abstract ?? undefined, doi: c.doi ?? undefined,
    journal: c.journal ?? undefined,
    citations: c.citation_count, seed_reason: c.reason || undefined,
    seed_overlap_score: c.overlap_score,
    discovery_sources: c.sources?.length ? c.sources : ["s2"],
  } as PaperCreate;
}
